import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
  AssetProps,
  ColorProps,
} from './Helpers';

import Asset from './Asset';
import { getContainerStyles } from '../../../../utils/Utils';
import { FONT_VARIANT_CLASS_NAME } from '../../../../consts/consts';

export default class Values extends Component {
  static renderPoint({
    bodyFontSize,
    header,
    copy,
    textColor,
    images: [asset] = [],
    small,
    i,
  }) {
    const fontSizeClassName = FONT_VARIANT_CLASS_NAME[bodyFontSize || 'L'];

    return (
      <div key={i} className={classNames('values__point', { small })}>
        <div className="values__point-asset">
          <Asset asset={asset} imageProps={{ blurryPlaceholder: false }} />
        </div>
        <div
          className="values__point-copy"
          style={getContainerStyles(null, textColor)}
        >
          <p
            className={classNames('values__point-copy--heavy', fontSizeClassName)}
          >
            {header}
          </p>
          <p className={fontSizeClassName}>{copy}</p>
        </div>
      </div>
    );
  }

  render() {
    const {
      anchor,
      backgroundColor,
      bodyFontSize,
      textColor,
      header,
      points,
      images: [asset],
    } = this.props;

    return (
      <section
        id={anchor || undefined}
        className="values"
      >
        {header && (
          <div className="values__header">
            <h2>
              {header}
            </h2>
          </div>
        )}
        {asset && (
          <div className="values__banner">
            <Asset asset={asset} />
          </div>
        )}
        <div
          className="values__points-wrapper"
          style={getContainerStyles(backgroundColor, null)}
        >
          {points.length && (
            <div className="values__points">
              {points.map((point, i) => Values.renderPoint({
                ...point,
                bodyFontSize,
                i,
                textColor,
                small: points.length > 3,
              }))}
            </div>
          )}
        </div>
      </section>
    );
  }
}

Values.defaultProps = {
  images: [],
  points: [],
};

Values.propTypes = {
  anchor: PropTypes.string,
  bodyFontSize: PropTypes.string,
  backgroundColor: ColorProps,
  textColor: ColorProps,
  header: PropTypes.string,
  images: PropTypes.arrayOf(AssetProps),
  points: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string,
    copy: PropTypes.string,
    images: PropTypes.arrayOf(AssetProps),
  })),
};
